import Vue from 'vue'
import * as types from './mutation_types'

export default {
  putListOfCalledAPI: (context, payload) => {
    context.commit(types.PUSH_LIST_OF_CALLED_API, payload)
  },
  setDisplayCateData: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_CATE_DATA, payload)
  },
  setDisplayData: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_DATA, payload)
  },
  setDisplayPage: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_PAGE, payload)
  },
  setVideoData: (context, payload) => {
    context.commit(types.UPDATE_VIDEO_DATA, payload)
  },
  setGorillaChart: (context, payload) => {
    context.commit(types.UPDATE_GORILLA_CHART_DATA, payload)
  },
  setCardCorpData: (context, payload) => {
    context.commit(types.UPDATE_CARD_CORP_DATA, payload)
  },
  setCardCorpEventData: (context, payload) => {
    context.commit(types.UPDATE_CARD_CORP_EVENT_DATA, payload)
  },
  setCardDataForSearch: (context, payload) => {
    context.commit(types.UPDATE_CARD_DATA_FOR_SEARCH, payload)
  },
  setCardDataQueryAndResult: (context, payload) => {
    context.commit(types.UPDATE_CARD_DATA_QUERY_AND_RESULT, payload)
  },
  setBenefitDataDepth: (context, payload) => {
    context.commit(types.UPDATE_BENEFIT_DATA_DEPTH, payload)
  },
  setBenefitDataFlat: (context, payload) => {
    context.commit(types.UPDATE_BENEFIT_DATA_FLAT, payload)
  },
  setCardCoverData: (context, payload) => {
    context.commit(types.UPDATE_CARD_COVER_DATA, payload)
  },
  setOpenCompareSlot: (context, payload) => {
    context.commit(types.CHANGE_OPEN_COMPARE_SLOT, payload)
  },
  setCompareSlotBigSize: (context, payload) => {
    context.commit(types.CHANGE_SIZE_COMPARE_SLOT, payload)
  },
  setToastBannerSmallSize: (context, payload) => {
    context.commit(types.CHANGE_SIZE_TOAST_BANNER, payload)
  },
  setCompareSlotBigSizePosition: (context, payload) => {
    context.commit(types.UPDATE_COMPARE_SLOT_POSITION, payload)
  },
  setCompareSlotData: (context, payload) => {
    Vue.localStorage.set('compareSlotData', JSON.stringify(payload))
    context.commit(types.UPDATE_COMPARE_SLOT_DATA, payload)
  },
  setCompareRcmdModal: (context, payload) => {
    context.commit(types.UPDATE_COMPARE_RCMD_MODAL, payload)
  },
  setCurrentChartTitle: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_CHART_TITLE, payload)
  },
  setOpenAllChartDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_ALL_CHART_DIALOG, payload)
  },
  setOpenAwd1Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_AWD1_DIALOG, payload)
  },
  setOpenAwd2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_AWD2_DIALOG, payload)
  },
  setOpenAwd3Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_AWD3_DIALOG, payload)
  },
  setOpenAwd4Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_AWD4_DIALOG, payload)
  },
  setOpenAwd5Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_AWD5_DIALOG, payload)
  },
  setOpenSpe1Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SPE1_DIALOG, payload)
  },
  setOpenSpe2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SPE2_DIALOG, payload)
  },
  setOpenSpe3Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SPE3_DIALOG, payload)
  },
  setOpenSpe4Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SPE4_DIALOG, payload)
  },
  setOpenReturn1Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_RETURN1_DIALOG, payload)
  },
  setOpenReturn2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_RETURN2_DIALOG, payload)
  },
  setOpenReturn3Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_RETURN3_DIALOG, payload)
  },
  setOpenReturn4Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_RETURN4_DIALOG, payload)
  },
  setOpenCheckDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_CHECK_DIALOG, payload)
  },
  setOpenBrandDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_BRAND_DIALOG, payload)
  },
  setOpenKBcorpDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_KBCORP_DIALOG, payload)
  },
	setOpenShareDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHARE_DIALOG, payload)
  },
	setOpenShare2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHARE2_DIALOG, payload)
  },
	setOpenFaqDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FAQ_DIALOG, payload)
  },
	setOpenFooterDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FOOTER_DIALOG, payload)
  },
	setOpenShorts1Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHORTS1_DIALOG, payload)
  },
	setOpenShorts2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHORTS2_DIALOG, payload)
  },
	setOpenShorts3Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHORTS3_DIALOG, payload)
  },
	setOpenShorts4Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHORTS4_DIALOG, payload)
  },
	setOpenShorts5Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHORTS5_DIALOG, payload)
  },
  setCurrentCalendarLabel: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_CALENDAR_LABEL, payload)
  },
  setOpenCalendarDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_CALENDAR_DIALOG, payload)
  },
  setCurrentTeam: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_TEAM, payload)
  },
  setCurrentTeamChartData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_TEAM_CHART_DATA, payload)
  },
  setCurrentTeamCardData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_TEAM_CARD_DATA, payload)
  },
  setCurrentTeamEventData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_TEAM_EVENT_DATA, payload)
  },
  setCurrentEventData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_EVENT_DATA, payload)
  },
  setOpenTeamDropdown: (context, payload) => {
    context.commit(types.UPDATE_OPEN_DROPDOWN, payload)
  },
  setCurrentContentsData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_CONTENTS_DATA, payload)
  },
  setCurrentCard: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_CARD, payload)
  },
  setSlotIndex: (context, payload) => {
    context.commit(types.CHANGE_SLOT_INDEX, payload)
  },
  openEventLayer: (context, payload) => {
    context.commit('SET_EVENT_LAYER_DETAIL', payload)
    context.commit('SET_EVENT_LAYER_OPEN', true)
  },
  closeEventLayer: (context) => {
    context.commit('SET_EVENT_LAYER_OPEN', false)
    context.commit('SET_EVENT_LAYER_DETAIL', '')
  },
}
